export const JOB_TYPE_METADATA = {
  gene: {
    label: 'Gene',
    placeholder: 'Gene symbol (e.g., CFTR)',
    description: 'HGNC gene symbol search',
    icon: 'fa-dna',
    cssClass: 'gene'
  },
  'single-variant': {
    label: 'Single Variant',
    placeholder: 'Variant (e.g., chr11_5227002_A_T)',
    description: 'HGVS, coordinate, or variant ID',
    icon: 'fa-code-branch',
    cssClass: 'variant'
  },
  'single-sv-cnv': {
    label: 'Single CNV/SV',
    placeholder: 'SV/CNV (e.g., chr10_17268558_17274050_DEL)',
    description: 'Single structural variant or copy number variation',
    icon: 'fa-project-diagram',
    cssClass: 'sv'
  },
  'multi-sv-cnv': {
    label: 'Multi SV/CNV',
    placeholder: 'Upload a VCF file',
    description: 'Analyze VCF file with structural variants and copy number variations',
    icon: 'fa-layer-group',
    cssClass: 'sv'
  },
  'multi-variant': {
    label: 'Multi Variant',
    placeholder: 'Upload a VCF file',
    description: 'Analyze a VCF file with multiple variants',
    icon: 'fa-file-medical-alt',
    cssClass: 'vcf'
  }
};

export const JOB_TYPE_ORDER = ['gene', 'single-variant', 'single-sv-cnv', 'multi-sv-cnv', 'multi-variant'];

export const normalizeJobType = (value = '') =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, '-');

export const getJobTypeKey = (value) => {
  const normalized = normalizeJobType(value);
  if (!normalized) return null;
  if (JOB_TYPE_METADATA[normalized]) return normalized;
  return JOB_TYPE_ORDER.find(key => normalized.startsWith(key)) || null;
};

export const getJobTypeMeta = (value) => {
  const key = getJobTypeKey(value);
  return key ? { ...JOB_TYPE_METADATA[key], key } : null;
};

export const formatJobTypeLabel = (value) => {
  const key = getJobTypeKey(value);
  if (key && JOB_TYPE_METADATA[key]?.label) {
    return JOB_TYPE_METADATA[key].label;
  }

  const normalized = normalizeJobType(value);
  if (!normalized) return '';

  return normalized
    .split('-')
    .filter(Boolean)
    .map(part => (part.length <= 3 ? part.toUpperCase() : part.charAt(0).toUpperCase() + part.slice(1)))
    .join(' ');
};
